/** 新闻中心列表与详情共用数据源（便于分页与上下篇） */

export type NewsArticle = {
  id: string;
  title: string;
  summary: string;
  /** YYYY-MM-DD */
  date: string;
  coverUrl: string;
  category: string;
  body: string[];
};

export const NEWS_PAGE_SIZE = 10;

const COVERS = [
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=960&q=80',
  'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=960&q=80',
  'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=960&q=80'
];

const TITLE_SEEDS = [
  'Hyxino 入选行业创新榜单',
  '发布新一代企业中台',
  '华东交付中心正式启用',
  '国产化 AI 算力新品发布会圆满举行',
  '与头部高校达成智慧校园战略合作',
  '医疗多模态筛查方案落地三甲医院',
  '海曦技术通过 ISO 27001 年度复审',
  '开源社区贡献度跻身国内前列',
  '边缘智算一体机斩获年度产品奖',
  '大模型推理引擎性能评测领先',
  '政企客户满意度调研结果公布',
  '加入上海市人工智能行业协会理事单位',
  '数字人课程平台服务百万师生',
  '供应链安全与合规白皮书发布',
  '海外业务拓展至东南亚市场',
  '研发中心扩容，算法团队规模翻倍',
  '与芯片原厂联合实验室揭牌',
  '校园招聘季正式启动',
  'ESG 报告披露碳中和路线图',
  '客服智能坐席系统全国上线',
  '数据要素流通试点项目入选',
  '行业沙龙「AI 向善」上海站回顾',
  '专利授权量突破百件',
  '合作伙伴大会发布生态激励计划',
  '内部知识库升级至 2.0',
  '年度用户大会定档三季度',
  '可视化编排工具开放公测',
  '安全红队演练实现零高危残留'
];

function buildBody(title: string, summary: string): string[] {
  return [
    `围绕「${title}」这一主题，海曦技术在前期调研、方案设计与工程落地各环节保持高标准交付，确保与客户及生态伙伴的目标一致。`,
    summary + ' 我们将持续跟踪项目成效，迭代产品能力，并依托全国交付网络提供稳定运维与专家支持。',
    '在自主创新与开放合作并重的原则下，海曦技术欢迎产业链伙伴参与联合方案共建，共同推动国产化 AI 在关键行业的深度应用。',
    '如需进一步了解合作模式、产品试用或媒体采访，请通过官网「联系我们」页面与我们取得联系，我们将尽快安排对口同事对接。'
  ];
}

function isoDateUtc(year: number, month0: number, day: number): string {
  const d = new Date(Date.UTC(year, month0, day));
  return d.toISOString().slice(0, 10);
}

/** 生成固定 27 条，满足多页分页演示（10/10/7） */
export const NEWS_CATALOG: NewsArticle[] = TITLE_SEEDS.map((title, i) => {
  const date = isoDateUtc(2026, 3, 20 - i);
  const summary = `海曦技术持续深耕政企与教育等场景，本条动态聚焦「${title}」相关进展与价值沉淀，欢迎阅读了解。`;
  return {
    id: `n-${i + 1}`,
    title,
    summary,
    date,
    coverUrl: COVERS[i % COVERS.length],
    category: i % 3 === 0 ? '公司动态' : i % 3 === 1 ? '产品发布' : '行业观察',
    body: buildBody(title, summary)
  };
});

export function formatNewsCardDate(iso: string): { dayMonth: string; year: string } {
  const [y, m, d] = iso.split('-');
  if (!y || !m || !d) return { dayMonth: '--', year: '--' };
  return { dayMonth: `${m}.${d}`, year: y };
}

export function getNewsById(id: string): NewsArticle | undefined {
  return NEWS_CATALOG.find((a) => a.id === id);
}

export function getNewsNeighbors(id: string): { prev: NewsArticle | null; next: NewsArticle | null } {
  const i = NEWS_CATALOG.findIndex((a) => a.id === id);
  if (i < 0) return { prev: null, next: null };
  return {
    prev: i > 0 ? NEWS_CATALOG[i - 1]! : null,
    next: i < NEWS_CATALOG.length - 1 ? NEWS_CATALOG[i + 1]! : null
  };
}
